import React from 'react';

import About from './about';

const AboutPage = () => (
  <About
    borderColor={Styles.color.black}
    sectionHeadings={false}
    showActions={true}
    showLanguageSelector={true}
  />
);

export default AboutPage;
